'use strict';
var _ = require('underscore');
var request = require('superagent');
var assetsHelper = require('./assetsHelper');

var defaulgConfig = window.isDev ?
  {
    iOSGuide: true,
    logo: assetsHelper.getAsset('logo_for_ios.png'),
    showControlPanel: true, // 显示控制面板
    shell: '', // 外壳
    background: '#F0F0F0', // 背景色
    alwaysShowLinks: true, // 始终显示链接
    hoverShowLinks: false, // 鼠标滑过时显示链接
    hoverShowRemarks: true, //鼠标滑过时，显示备注
    showComments: true, // 显示批注
    showQRCode: true, // 显示二维码
    hintLinks: false, // 闪烁提示链接
    scrollRemarks: true, // 链接自动滚动
    isShowAllPageNode: true,    //是否显示被隐藏的节点
    isShowPreviewTools: true,    //是否显示导航工具栏
    showRemarkFlag: true // 是否显示备注的小图标
  } : {
    iOSGuide: true,
    logo: assetsHelper.getAsset('logo.png'),
    showControlPanel: true, // 显示控制面板
    shell: '', // 外壳
    background: '#F0F0F0', // 背景色
    alwaysShowLinks: false, // 始终显示链接
    hoverShowLinks: false, // 鼠标滑过时显示链接
    hoverShowRemarks: true, //鼠标滑过时，显示备注
    showComments: true, // 显示批注
    showQRCode: true, // 显示二维码
    hintLinks: false, // 闪烁提示链接
    scrollRemarks: true, // 链接自动滚动
    isShowAllPageNode: false,    //是否显示被隐藏的节点
    isShowPreviewTools: true,    //是否显示导航工具栏
    showRemarkFlag: true // 是否显示备注的小图标
  };

var config = _.extend(defaulgConfig, window.config);

// 导出时中的设置有时候 logo 可能为空，此时忽略掉，使用默认配置
if (window.config && !window.config.logo) {
  config.logo = defaulgConfig.logo;
}

exports.getConfig = function (cb) {
  if (window.mockplus || window.enterprise) {
    return request.get('config.json?rnd=' + Math.random()).end(function (err, res) {
      var newConfig;
      if (err) {
        return cb(null, config);
      }
      try {
        console.log(res.body);
        newConfig = _.extend(config, res.body);
        console.log(newConfig);
        if (!newConfig.logo) {
          newConfig.logo = assetsHelper.getAsset('logo.png');
        }
        cb(null, newConfig);
      } catch (e) {
        cb(null, config);
      }
    });
  }
  cb(null, config);
};

exports.notForceUseCurrentBrowser = function () {
  return window.location.href.indexOf('force=1') === -1;
};



// WEBPACK FOOTER //
// ./src/helper/configHelper.js